// Build identity — the only config that stays in source (not Doppler).
// Everything else is sourced from EXPO_PUBLIC_* env vars (see ./fromEnv.js),
// injected per-environment by Doppler (project `ojs`, configs dev/stg/prd).
//
// `local` and `test` reuse the Doppler `dev` config; they share development's
// identity and differ only via the override logic in ./bootstrap.js.

const development = {
    env: 'development',
    appName: 'Just Salad dev',
    appSlug: 'justsalad-development',
    expoUid: 'd0a42a9e-1116-4a00-a751-35be2b72ec1c',
    iosBundleId: 'com.justsalad.justsalad-development',
    androidPackage: 'com.justsalad.justsalad.development'
};

const identity = {
    development,
    local: { ...development, env: 'local' },
    test: { ...development, env: 'test' },
    staging: {
        env: 'staging',
        appName: 'Just Salad Staging',
        appSlug: 'justsalad-staging',
        expoUid: '4135d776-5b7f-4f98-855b-4d8c7dec7125',
        iosBundleId: 'com.justsalad.justsalad-staging',
        androidPackage: 'com.justsalad.justsalad.staging'
    },
    production: {
        env: 'production',
        appName: 'Just Salad',
        appSlug: 'justsalad',
        expoUid: 'e9cdcd64-e60a-4ec2-a92f-6fefe1423148',
        iosBundleId: 'com.justsalad.justsalad.ios',
        androidPackage: 'com.justsalad.justsalad.android.app'
    }
};

module.exports = identity;
